export default __webpack_public_path__ + "static/media/038-summer.7486fb0d.svg";